// extracted by mini-css-extract-plugin
module.exports = {"containerClass":"Chart_containerClass__3gf_0","valueClass":"Chart_valueClass__2j3r7","barClass":"Chart_barClass__SbN4a","labelClass":"Chart_labelClass__2vVP4"};